export default __webpack_public_path__ + "static/media/slide4-app.3ce99a9d.png";